module.exports = __webpack_public_path__ + "static/media/component-icon-filled.5b4960bb.svg";